import fetch from 'isomorphic-fetch';
import base64 from 'base-64';
import url from 'url';

import { ENV } from '../settings/env';
import { parsedUrl } from './url';

const authorizations = {
  cdc: base64.encode('dior_bo:z7VRnWnefcej'),
  pcd: base64.encode('smile:(AKA94!)')
};

export default function(requestUrl, data = {}, authorization) {
  if (ENV === 'preProduction' && authorization && authorizations[authorization]) {
    data.headers = data.headers || {};
    data.headers.Authorization = 'Basic ' + authorizations[authorization];
  }

  const parsedRequestUrl = url.parse(requestUrl);
  if (!parsedRequestUrl.hostname || parsedRequestUrl.hostname === parsedUrl.hostname) {
    data.credentials = 'same-origin';
  }

  return fetch(requestUrl, data);
}



// WEBPACK FOOTER //
// ./src/services/fetch.js